import { useState } from 'react'

/**
 * Custom hook to toggle a masks visibility
*/
const useHandleMask = () => {
    const [showMask, setShowMask] = useState(false)
    const handleShowMask = () => {
        setShowMask(true)
    }
    const handleCloseMask = () => {
        setShowMask(false)
    }
    const toggleShowMask = () => {
        setShowMask(!showMask)
    }

    //returns values as array destructuring, so that the calling component can rename the values if reused multiple times
    return [showMask, handleShowMask, handleCloseMask, toggleShowMask]
}

/**
 * Custom hook to toggle a alert messages visibility
*/
const useHandleAlertMessage = () => {
    const [showAlertMessage, setShowAlert] = useState(false)
    const openAlert = () => {
        setShowAlert(true)
    }
    const closeAlert = () => {
        setShowAlert(false)
    }

    return { showAlertMessage, openAlert, closeAlert }
}

export { useHandleMask, useHandleAlertMessage }